<template>
  <div>
    <div class="first_registration">
      <div class="regist_info">
        <h1>教练员注册页</h1>
        <div class="basic_information">
          <div class="info_left">
            <p>教练员基本信息</p>
          </div>
          <div class="info_right">
            <registrationForm ref="registrationForm" :uptoken="uptoken"></registrationForm>
          </div>
        </div>
        <div class="evidence">
          <div class="info_left">
            <p>证明材料</p>
          </div>
          <div class="info_right">
            <div class="card_box">
              <p>
                身份证照片
                <span>*</span>
              </p>
              <ul class="upload_card">
                <li>
                  <el-upload
                    :before-upload="$event=>handleBefore($event,'positive')"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :data="{token: uptoken}"
                    accept="image/jpeg, image/jpg, image/png"
                    action="//up-z1.qiniup.com"
                  >
                    <img
                      :src="imgList.frontImage"
                      v-if="imgList.frontImage"
                      style="width:85.6mm;height:54mm;margin-bottom:10px"
                      alt
                    />
                    <el-button
                      v-if="!imgList.frontImage"
                      :loading="loadingData.positive"
                      type="primary"
                      icon="el-icon-upload"
                    >选择上传文件</el-button>
                  </el-upload>
                  <p v-if="!imgList.frontImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  <p class="upload_tip">正面</p>
                </li>
                <li>
                  <el-upload
                    :before-upload="$event=>handleBefore($event,'back')"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    :data="{token: uptoken}"
                    accept="image/jpeg, image/jpg, image/png"
                    action="//up-z1.qiniup.com"
                  >
                    <img
                      :src="imgList.backImage"
                      v-if="imgList.backImage"
                      style="width:85.6mm;height:54mm;margin-bottom:10px"
                      alt
                    />
                    <el-button
                      v-if="!imgList.backImage"
                      :loading="loadingData.back"
                      type="primary"
                      icon="el-icon-upload"
                    >选择上传文件</el-button>
                  </el-upload>
                  <p v-if="!imgList.backImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
                  <p class="upload_tip">反面</p>
                </li>
              </ul>
            </div>
            <div class="graduation_box">
              <p>
                培训结业证书内页
                <span>*</span>
              </p>
              <div class="upload_graduation">
                <el-upload
                  :before-upload="$event=>handleBefore($event,'graduation')"
                  :on-success="uploadSuccess"
                  :show-file-list="false"
                  :data="{token: uptoken}"
                  accept="image/jpeg, image/jpg, image/png"
                  action="//up-z1.qiniup.com"
                >
                  <img
                    :src="imgList.trainImage"
                    v-if="imgList.trainImage"
                    style="width:85.6mm;height:54mm;;margin-bottom:10px"
                    alt
                  />
                  <el-button
                    v-if="!imgList.trainImage"
                    :loading="loadingData.graduation"
                    type="primary"
                    icon="el-icon-upload"
                  >选择上传文件</el-button>
                </el-upload>
                <p v-if="!imgList.trainImage" class="upload_format">只能上传jpg/png格式文件，文件不能超过5M</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="remark">
          <div class="info_left">
            <p>备注</p>
          </div>
          <div class="info_right">
            <el-input
              type="textarea"
              class="remark_input"
              v-model="query.remarks"
              :autosize="{minRows:2,maxRows:5}"
              resize="none"
              placeholder="输入内容"
            ></el-input>
            <div class="upload_img">
              <el-upload
                action="//up-z1.qiniup.com"
                multiple
                :before-upload="handleBeforeMultipie"
                :on-success="uploadSuccessMultipie"
                :show-file-list="false"
                :file-list="remarksFileList"
                :limit="9"
                :on-exceed="handleExceed"
                :data="{token: uptoken}"
                accept="image/jpeg, image/jpg, image/png"
              >
                <el-button>添加附件</el-button>
              </el-upload>
              <div style="display:flex;flex-wrap:wrap">
                <viewer class="rows" :images="imgList.remarksImage">
                  <section v-for="(item,index) in imgList.remarksImage" :key="item">
                    <img class="up_img" :src="item" alt />
                    <span class="close_btn" @click="deleteRemarkImage(index)">×</span>
                  </section>
                </viewer>
              </div>
            </div>
          </div>
        </div>
        <div class="notice">
          <div class="notice_left">
            <p>须知</p>
          </div>
          <div class="notice_right">
            <el-checkbox v-model="checked">本人已知晓浙江省教育厅关于教练员资格的相关规定，承诺所填内容真实。</el-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="btn_box">
      <el-button
        style="width:90px"
        :disabled="!checked"
        class="save_btn"
        @click="submits(0)"
        :loading="saveLoading"
      >保存</el-button>
      <el-button
        :loading="btnLoading"
        :disabled="!checked && isRegistStatus"
        style="width:90px;margin:0 40px"
        class="normal_btn"
        @click="submits(3)"
      >提交</el-button>
      <el-button style="width:90px" class="normal_btn" v-if="false">打印</el-button>
    </div>
  </div>
</template>
<script>
import { isRegist } from "@/api/time-management.js";
import registrationForm from "./component/registration_form";
import { getUploadToken } from "@/api/upload.js";
import { addCoach } from "@/api/coach.js";
import { message, btn } from "@/common/js/mixins.js";
export default {
  mixins: [message, btn],
  components: {
    registrationForm
  },
  data() {
    return {
      isRegistStatus: false,
      fileList: [],
      remarksFileList: [],
      checked: false,
      uptoken: "",
      uploadType: "",
      files: "",
      saveLoading: false,
      imgList: {
        frontImage: "", //身份证正面(图片)
        backImage: "", //身份证背面(图片)
        trainImage: "", //结业证书（图片）
        remarksImage: [] //附件图片
      },
      query: {
        remarks: "",
        frontImage: "", //身份证正面
        backImage: "", //身份证背面
        trainImage: "", //结业证书
        remarks: "",
        remarksImage: []
      },
      loadingData: {
        positive: false,
        back: false,
        graduation: false
      }
    };
  },
  methods: {
    // 点击提交按钮
    submits(type) {
      this.$refs.registrationForm
        .submits()
        .then(res => {
          if (!res) return;
          if (!this.query.frontImage)
            return this.openWarn("请上传身份证正面照");
          if (!this.query.backImage) return this.openWarn("请上传身份证反面照");
          if (!this.query.trainImage) return this.openWarn("请上传培训证书页");
          if (type === 0) this.saveLoading = true;
          else this.openBtn();
          let { remarksImage } = this.query;
          addCoach({
            ...res,
            ...this.query,
            remarksImage: remarksImage.join(","),
            state: type
          })
            .then(res => {
              if (type === 0) this.saveLoading = false;
              else this.closeBtn();
              this.$message({
                type: "success",
                message: type === 0 ? "保存成功！" : "提交成功！"
              });
              this.$router.push("/update-coach-registration");
            })
            .catch(err => {
              if (type === 0) this.saveLoading = false;
              else this.closeBtn();
            });
        })
        .catch(err => {});
    },
    // 附件图片预览
    show(index) {
      const viewer = this.$el.querySelectorAll(".rows")[index].$viewer;
      viewer.show();
    },
    // 删除附件图片
    deleteRemarkImage(index) {
      this.remarksFileList.splice(index, 1);
      this.imgList.remarksImage.splice(index, 1);
      this.query.remarksImage.splice(index, 1);
    },
    // 超出上传限制个数
    handleExceed() {
      this.openWarn("最多只能上传9张图片！");
    },
    // 附件上传前判断格式
    handleBeforeMultipie(file) {
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 5; //图片大小不超过5MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        return false;
      }
      this.fileList.push(file);
      return testmsg && isLt5M;
    },
    // 附件上传成功
    uploadSuccessMultipie(data, file, fileList) {
      this.remarksFileList = fileList;
      this.query.remarksImage.push(data.key);
      this.imgList.remarksImage.push(window.URL.createObjectURL(file.raw));
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].name === file.name) {
          this.fileList.splice(i, 1);
          i--;
        }
      }
    },
    // 上传前判断size及文件格式
    handleBefore(file, type) {
      this.uploadType = type;
      this.files = file;
      if (type === "positive") this.loadingData.positive = true;
      else if (type === "back") this.loadingData.back = true;
      else this.loadingData.graduation = true;
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 5; //图片大小不超过2MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        Object.assign(this.loadingData, {
          positive: false,
          back: false,
          graduation: false
        });
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        Object.assign(this.loadingData, {
          positive: false,
          back: false,
          graduation: false
        });
        return false;
      }
      return testmsg && isLt5M;
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      this.$message.success("上传成功！");
      if (this.uploadType === "positive") {
        this.query.frontImage = response.key;
        this.imgList.frontImage = window.URL.createObjectURL(this.files);
        this.loadingData.positive = false;
      } else if (this.uploadType === "back") {
        this.query.backImage = response.key;
        this.imgList.backImage = window.URL.createObjectURL(this.files);
        this.loadingData.back = false;
      } else {
        this.query.trainImage = response.key;
        this.imgList.trainImage = window.URL.createObjectURL(this.files);
        this.loadingData.graduation = false;
      }
    },
    // 获取token
    getToken() {
      getUploadToken({
        type: 1
      })
        .then(res => {
          this.uptoken = res;
        })
        .catch(err => {});
    },
    // 清空表单
    resetForm() {
      this.$refs.registrationForm.resetForm();
    },
    // 是否可以注册
    isRegists() {
      return new Promise((resolve, reject) => {
        isRegist({
          type: 2
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mounted() {
    this.isRegists()
      .then(res => {
        this.isRegistStatus = res;
        this.getToken();
      })
      .catch(err => {});
  }
};
</script>
<style lang="less" scoped>
@borders: 1px solid #979797;
.first_registration {
  border: @borders;
  min-width: 900px;
  margin: 0 230px 0 105px;
  .regist_info {
    width: 100%;
    min-width: 900px;
    > h1 {
      line-height: 64px;
      text-align: center;
      font-size: 24px;
      color: #222;
    }
    > .basic_information {
      border-top: @borders;
      display: flex;
      min-width: 900px;

      .info_right {
        flex: 1;
      }
    }
  }
  .evidence {
    border-top: @borders;
    display: flex;
    .info_right {
      padding: 20px 25px;
      flex: 1;
      p {
        display: flex;
        span {
          color: #fd6666;
        }
      }
      .graduation_box {
        width: 100%;
        .upload_graduation {
          margin-top: 20px;
          width: 48%;
          height: 300px;
          background: #e6e6e6;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .upload_format {
            font-size: 14px;
            margin: 20px 0;
          }
        }
      }
      .upload_card {
        margin: 20px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        li {
          width: 48%;
          height: 300px;
          background: #e6e6e6;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .upload_format {
            font-size: 14px;
            margin: 20px 0;
          }
          .upload_tip {
            font-size: 18px;
          }
        }
      }
    }
  }
  .remark {
    border-top: @borders;
    display: flex;
    align-items: center;
    .info_left {
      width: 103px;
      padding: 20px 0;
      border-right: none;
    }
    .info_right {
      border-left: @borders;
      flex: 1;
      padding: 20px;
      .upload_img {
        display: flex;
      }
      .rows {
        display: flex;
        flex-wrap: wrap;
        > section {
          width: 100px;
          height: 100px;
          position: relative;
          margin: 0 0 20px 20px;
          > .up_img {
            cursor: pointer;
            border: 1px solid rgba(0, 0, 0, 0.2);
            width: 100%;
            height: 100%;
          }
          > .close_btn {
            cursor: pointer;
            position: absolute;
            top: -6px;
            right: -6px;
            width: 14px;
            height: 14px;
            line-height: 12px;
            font-size: 12px;
            color: #fff;
            text-align: center;
            background: #1e63b0;
            border-radius: 50%;
          }
        }
      }
    }
    /deep/ .remark_input .el-textarea__inner {
      border: none;
    }
  }
  .notice {
    border-top: @borders;
    display: flex;
    height: 64px;
    align-items: center;
    .notice_left {
      line-height: 64px;
      border-right: @borders;
      width: 104px;
      text-align: center;
    }
    .notice_right {
      padding-left: 25px;
    }
  }
  .info_left {
    width: 104px;
    border-right: @borders;
    display: flex;
    align-items: center;
    justify-content: center;
    > p {
      line-height: 24px;
      width: 24px;
      font-size: 20px;
      text-align: center;
    }
  }
}
.btn_box {
  margin: 40px 230px 0 105px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.save_btn {
  background: #1e63b0;
  color: #fff;
}
.normal_btn {
  background: #fff;
  color: #1e63b0;
  border: 1px solid #1e63b0;
}
.disable_btn {
  background-color: #fff;
  border-color: #ebeef5;
  color: #c0c4cc;
}
</style>